export default __webpack_public_path__ + "static/media/teeth_v2_bg_thumbnail.1b2bfaaf.png";